import { createRouter, createWebHashHistory } from 'vue-router'
import MainLayout from '../layout/index.vue'

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/login',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('../views/home/HomePage.vue'),
        meta: { title: '平台首页', icon: 'home' }
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('../views/order/OrderPage.vue'),
        meta: { title: '查课下单', icon: 'eye' }
      },
      {
        path: 'batchQuery',
        name: 'BatchQuery',
        component: () => import('../views/batchQuery/BatchQueryPage.vue'),
        meta: { title: '批量查课', icon: 'search' }
      },
      {
        path: 'batchOrder',
        name: 'BatchOrder',
        component: () => import('../views/batchOrder/BatchOrderPage.vue'),
        meta: { title: '批量下单', icon: 'file-add' }
      },
      {
        path: 'orderManage',
        name: 'OrderManage',
        component: () => import('../views/orderManage/OrderManagePage.vue'),
        meta: { title: '国开订单', icon: 'ordered-list' }
      },
      {
        path: 'shiyanOrder',
        name: 'shiyanOrder',
        component: () => import('../views/shiyanOrder/ShiyanOrderPage.vue'),
        meta: { title: '实验订单', icon: 'ordered-list' }
      },
      {
        path: 'hebeiOrder',
        name: 'hebeiOrder',
        component: () => import('../views/hebeiOrder/hebeiOrderPage.vue'),
        meta: { title: '河北开放', icon: 'ordered-list' }
      },
      {
        path: 'agent',
        name: 'Agent',
        component: () => import('../views/agent/AgentPage.vue'),
        meta: { title: '我的代理', icon: 'team' }
      },
      {
        path: 'consumption',
        name: 'Consumption',
        component: () => import('../views/consumption/ConsumptionPage.vue'),
        meta: { title: '消费记录', icon: 'account-book' }
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: () => import('../views/feedback/FeedbackPage.vue'),
        meta: { title: '问题反馈', icon: 'message' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/profile/ProfilePage.vue'),
        meta: { title: '个人中心', icon: 'user' }
      },
      {
        path: 'announcement',
        name: 'Announcement',
        component: () => import('../views/announcement/AnnouncementPage.vue'),
        meta: { title: '公告列表', icon: 'notification', roles: ['admin'] }
      },
      {
        path: 'priceList',
        name: 'PriceList',
        component: () => import('../views/priviceList/PriceListPage.vue'),
        meta: { title: '价格列表', icon: 'dollar' }
      },
      {
        path: 'announcement/edit',
        name: 'AnnouncementEdit',
        component: () => import('../views/announcement/AnnouncementEdit.vue'),
        meta: { title: '公告编辑', icon: 'edit', roles: ['admin'] }
      }
    ]
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 获取token
  const token = localStorage.getItem('token')

  // 如果访问登录页面，直接放行
  if (to.path === '/login') {
    next()
    return
  }

  // 如果没有token，重定向到登录页
  if (!token) {
    next('/login')
    return
  }

  try {
    // 优先从 localStorage 获取用户信息
    let userInfo = localStorage.getItem('userInfo')

    if (userInfo) {
      // 使用缓存的用户信息
      userInfo = JSON.parse(userInfo)
      console.log('使用缓存的用户信息')
    } else {
      // 缓存不存在时才请求接口
      console.log('缓存不存在，请求用户信息...')
      const response = await fetch('http://8.130.14.101:60000/api/NewManage/userinfo', {
        headers: {
          'X-token': token
        }
      })
      const result = await response.json()

      if (result.code === 200 && result.data) {
        userInfo = result.data
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      } else {
        console.error('获取用户信息失败:', result)
        next('/login')
        return
      }
    }

    // 解析roles字段
    let userRoles = []
    try {
      if (userInfo.roles) {
        const parsed = JSON.parse(userInfo.roles.replace(/\\/g, ''))
        userRoles = Array.isArray(parsed) ? parsed : [parsed]
      }
    } catch (e) {
      userRoles = userInfo.roles ? [userInfo.roles] : []
    }

    // 检查路由是否需要特定角色权限
    if (to.meta.roles) {
      const hasRequiredRole = to.meta.roles.some(role => userRoles.includes(role))
      if (!hasRequiredRole) {
        console.log('权限不足，重定向到首页')
        next('/home')
        return
      }
    }

    // 有token且权限验证通过，放行
    next()
  } catch (error) {
    console.error('请求用户信息出错:', error)
    next('/login')
  }
})

export default router
